import React from "react";
import ReactDOM from "react-dom/client";
import {} from "./jquery.SimpleCropper.js";
import {} from "./jquery.Jcrop.js";
import $ from "jquery";

export class UploadBackgroundPic extends React.Component {
  constructor(props) {
    super(props);
    //sambung buat a function where, all the calling is in one place For upload Pic
    this.Initializer();
  }
  componentDidMount() {
    $(".cropme_profile_picture_A_container").simpleCropper();
  }

  Initializer() {
    var v = document.createElement("div");
    v.id = "cropper_holder";
    document.body.appendChild(v);
  }

  nextbutton() {
    document.getElementById("i_profile_B").innerHTML =
      "new_current_background.jpg";
    document.getElementById("black_container").style.display = "none";
  }

  render() {
    return (
      <div
        className="text-center relative"
        style={{ textAlign: "-webkit-center" }}
      >
        <label
          class="block text-gray-700 text-sm font-bold mb-2 text-center"
          for="photo"
        >
          Profile Photo <span class="text-red-600"> </span>
        </label>
        <div className="mt-2 w-[800px]" x-show="! photoPreview">
          <img
            src={document.getElementById("i_background_profile").src}
            className="w-full h-80 m-auto shadow"
            id="profile_picture_A"
          />
        </div>
        <button
          type="button"
          id="cropme_profile_picture_A_container"
          className="cropme_profile_picture_A_container inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md font-semibold text-xs text-gray-700 uppercase tracking-widest shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-400 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150 mt-2 ml-3"
        >
          Select New Photo
        </button>
        <div class="flex justify-end items-end h-1/5 w-96 h-20">
          <button
            class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
            onClick={this.nextbutton}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }
}
